import {Link} from "react-router-dom";
import {Button} from "react-bootstrap";

// Icon and images
import {Logo} from "../../../assets/images";

const Navbar = () => {
    return (
        <div className="d-flex justify-content-between align-items-center py-3 container">
            <Link to="/">
                <img src={Logo} width={120} alt="Logo" />
            </Link>
            <Link
                className="text-decoration-none"
                to="https://play.google.com/store/apps/details?id=com.afausers&pcampaignid=web_share&pli=1"
                target="_blank"
            >
                <Button className="text-light rounded-pill fw-bold px-4" variant={"primary"}>
                    GET THE APP
                </Button>
            </Link>
        </div>
    );
};

export default Navbar;
